import styled from 'styled-components';

const Button = styled.button`
  width: 18px;
  border: none;
  background: transparent;
`;

export default Button;
